import useTemplateStatus from "./useTemplateStatus";

export default function useIsArchivedTemplate() {
  const status = useTemplateStatus();
  return status === "ARCHIVED";
}
